import './App.css'
import Header from './components/Header'
import Section from './components/Section'
import ContactForm from './components/ContactForm'
import Footer from './components/Footer'
 

function App() {
  return (
    <div className="app">
      <Header />

      <main className="main-content">
        <Section
          title="Vad och varför"
          content={
            <div className="intro-content">
              <p><b>Skrattyoga – det skapar energi, fokus och gemenskap.</b></p>
            
              <ul>
              <li><strong>Tid:</strong> 45–60 minuter</li>
              <li><strong>Gruppstorlek:</strong> 4–400 deltagare</li>
              </ul>

              <p>Perfekt inslag under en workshop, planeringsdag eller projektkick-off.</p>

              <h4>Därför fungerar det</h4>
              <ul>
              <li>Skratt ger en naturlig energiboost – kroppen stärks, sinnet slappnar av.</li>
              <li>Ett socialt klister – deltagarna blir snabbt bekväma med varandra.</li>
              <li>Efter skratt blir fokus och närvaro starkare – perfekt inför grupparbete.</li>
              </ul>

              <h4>När passar det?</h4>
              <ul>
              <li>Som uppvärmning inför sociala aktiviteter.</li>
              <li>Som start på en konferens eller en kick-off.</li>
              <li>När ni vill skapa snabb och äkta gruppkänsla.</li>
              </ul>

              <p>Skrattyoga fungerar i alla grupper och det blir garanterat skratt.</p>
          </div>
          }
          bgColor="var(--color-section-1)"
          imageUrl="/images/intro-image.jpg"
          type="image"
          imagePosition="right"
        />

        <Section
          title="Rekommendationer"
          content={
            <div className="references">
              <blockquote>"När vi samlade alla konsulter till konferens blev skrattyogan ett perfekt inslag. Den hjälpte oss att snabbt skapa gemensam energi och lägga grunden för en nystart efter en tuff period." - Pia Nilsson, VD Kvadrat Malmö</blockquote>
              <blockquote>"Vi samlade alla creatives på kontoret och lät oss boostas av ett skrattyogapass. Det kan jag varmt rekommendera!" - Nathalie Lameri, Boostified Pay</blockquote>
              <blockquote>"Skrattyogan blev ett mycket uppskattat event, det var minst sagt högt till tak. Tack för alla skratt!" - Linda Thörnqvist, styrelsen för personalklubb Eslövs kommun</blockquote>
              <blockquote>"Vi samlade all personal för en kick-off där Eric fick oss att skratta loss. Skrattet och kick-offen var mycket uppskattat." - Pernilla Pieplow Flodberg, biträdande rektor på Gymnasieskolan Vipan, Lunds kommun</blockquote>
              <blockquote>"Vi hade en AW där Eric gjorde att vi skrattade hejdlöst vilket stärkte vår sammanhållning." - Helena Nilsson, Trafikskolechef, Slottstadens Trafikskola</blockquote>
            </div>
          }
          bgColor="var(--color-section-2)"
          imageUrl="/images/references-image.jpg"
           type="image"
          imagePosition="left"
        />

        <Section
          title="Hur går det till"
          content={
            <div className="process">
              <h3>1. Inledande föredrag "Skratta din organisation frisk"</h3>
              <p>De fysiska effekterna av skrattövning är som att motionera, andningsvägar öppnas upp och blodet syresätts, endorfiner frigörs och immunförsvaret stärks. De psykiska effekterna är stressdämpande och välbehag, samt de sociala banden stärks av att skratta i grupp. Tillvarata förmågan att skratta i vardagen så att skrattets positiva hälsoeffekter kan fortgå.</p>
              
              <h3>2. Medvetna Skrattövningar som övergår till omedvetet skrattande</h3>
              <p>En-meters skrattet, drinkblandar-skrattet, starta gräsklipparen och lejonskrattet för att nämna några av övningar. Vi varvar med en andnings- och klappövning.</p>
              
              <h3>3. Fritt skrattande sittandes eller liggandes</h3>
              <p>Nu lämnar vi övningarna för att låta skrattet flöda fritt. Föregående moment har värmt upp gruppens skrattande. Denna övning skall inte styras och när det äkta och ohejdade skrattet tillåts bubbla upp i deltagarna varar den oftast mer än 20 minuter. Vi avslutar med att gemensam känna efter i kroppen efter alla skratt.</p>
            </div>
          }
          bgColor="var(--color-section-3)"
          imageUrl="/images/process-image.jpg"
           type="image"
          imagePosition="right"
        />

        <Section
          title="Om Laughter Yoga International"
          content={
            <div className='about'>
          <p>Det grundades 1995 av den indiske läkaren Dr. Madan Kataria, som kombinerade skrattövningar med yogisk andning. Det började med fem personer i en park i Mumbai och har vuxit till ett globalt nätverk med över 16 000 skrattklubbar i mer än 110 länder.</p>
          <p>30 år senare utbildar Dr. Kataria fortfarande skrattledare världen över och sprider sitt budskap om hälsa, glädje och fred genom skratt. Hans metod kräver inget skämt – bara viljan att skratta tillsammans. Genom dagliga onlinepass fortsätter han att inspirera människor till ett gladare liv.</p>
          <p>Läs mer på <a href="https://laughteryoga.org/" target="_blank" rel="noopener noreferrer">Laughter Yoga International</a>.</p>
</div>
}
          bgColor="var(--color-section-4)"
           type="pdf"
           imagePosition="right"
        >
          <div className="pdf-container">
            <embed src="https://csbf43f4d4183bbx455ex901.blob.core.windows.net/public/Certificate%20Laughter%20Leader%20Training.pdf" type="application/pdf" width="100%" height="600px" />
            <div className="pdf-fallback" style={{ textAlign: 'center', padding: '20px' }}>
              <p style={{ color: '#333', marginBottom: '0.5rem', fontSize: '1.1rem' }}>
                <strong>Certified Laughter Leader</strong>
              </p>
              <p style={{ color: '#555', marginBottom: '1.5rem' }}>
                Se mitt certifikat från Laughter Yoga International
              </p>
              <p style={{ color: '#666', marginBottom: '0.5rem', fontSize: '0.9rem', fontStyle: 'italic' }}>
                (Denna webbläsare kunde inte visa pdf på webbssidan.)
              </p>
              <a 
                href="https://csbf43f4d4183bbx455ex901.blob.core.windows.net/public/Certificate%20Laughter%20Leader%20Training.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-block',
                  padding: '12px 24px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                  fontSize: '1rem'
                }}
              >
                Visa PDF
              </a>
            </div>
          </div>
        </Section>

        <Section
          title="Kontakt"
          content={
            <>
              <p>Använd formulär eller skicka <a href="mailto:hej@skrattafriskt.se">e-post</a> för pris och tillgänglighet.</p>
              <p>
                Verksamheten utgår ifrån Malmö.</p>
              <p>
                Genom att kontakta oss godkänner du vår <a href="https://csbf43f4d4183bbx455ex901.blob.core.windows.net/public/Tecollab%20Privacy%20Policy.pdf" target="_blank" rel="noopener noreferrer">Integritetspolicy</a>.
              </p>
                <br />
              <p>Med vänlig hälsning,</p>
              <p>Eric Mases</p>
              <div className="contact-image-mobile">
                <img src="/images/Contact.jpg" alt="Eric Mases" />
              </div>
            </>
          }
          bgColor="var(--color-section-5)"
           type="contact"
           imagePosition="left"
        >
          <ContactForm />
        </Section>
      </main>

      <Footer />
    </div>
  );
}

export default App
